

<modal #modal>
    <div class="modal-content">
        <div class="modal-header">
            <h3>Har du glemt noget?</h3>
        </div>
        <div class="modal-body">
            <p>Du har stadig indhold i din kurv. Klik <span class="return-link" (click)="onAbortSignoutClick()">her</span> og vend tilbage til din kurv.</p>
        </div>
        <div class="modal-footer">
            <button class="btn btn-klred d-inline-block me-2" (click)="onExecuteSignoutClick()">Log ud</button>
        </div>
    </div>
</modal>



